<!-- ChoiceLinkButton.vue -->
<script lang="ts" setup>
    import "../../../css/choice.css"
    import * as ButtonProps from '../../lib/ButtonProps';
    import {IButtonProps } from '../../lib/ButtonProps';
    import { ActionButtonStyle, DefaultActionButtonValues } from '../../lib/Types/Types';
    import { DisplayStyle } from '../../Enums/UiEnums';
    import { computed } from 'vue';
    import { iconClass } from '../../lib/StyleHelpers';

    const props = withDefaults(defineProps<IButtonProps & {
        href: string,
        target?: string,
        marginEnd?:number
    }>(), {
        href: "",
        disabled: false,
        displayStyle: DisplayStyle.Primary,
        marginEnd: 1,
        action: ActionButtonStyle.NoIcon
    });

    const computedButtonClass = computed(() => {
        return [ButtonProps.getButtonClass(props), props.marginEnd ? `me-${props.marginEnd}` : ""].join(' ');
    });

    const computedButtonStyle = computed(() => {
        return ButtonProps.getButtonStyle(props);
    });    

    const defaultActionButtonValues = computed(() => DefaultActionButtonValues(props.action));    
    
    const computedActionIconClass = computed(() => 
        [defaultActionButtonValues.value.iconClass ?? iconClass(props.icon), "text-center"]);

    const buttonDisplayedText = computed<string>(() => {
        return (props.text ?? defaultActionButtonValues.value.baseText ?? props.action.toString() ?? "Button" );
    });

</script>

<template>
    <a :class="computedButtonClass" 
        :href="props.href"
        :target="props.target"
        :disabled="props.disabled" 
        :style="computedButtonStyle" 
        :title="props.tooltip">    
            <em :class="computedActionIconClass" :displayStyle="props.iconDisplayStyle"></em>
        {{buttonDisplayedText}}
    </a>
  </template>